import React from "react";
import { Route, Redirect, RouteProps, useParams } from "react-router";
import { connect } from "react-redux";

interface MyRouteProps extends RouteProps {
  component: any;
  authenticated: boolean;
  rest?: any;
}
function ValidRoute({
  component: Component,
  authenticated,
  ...rest
}: MyRouteProps) {
  const token = localStorage.userToken;
  return (
    <Route
      {...rest}
      render={(props) => {
        if (token) {
          return <Component />;
        } else {
          return (
            <>
              {console.log(props.location)}
              <Redirect
                to={{
                  pathname: "/user-login",
                  state: { from: props.location },
                }}
              />
            </>
          );
        }
      }}
    />
  );
}

const mapStateToProps = (state: any) => ({
  authenticated: state.user.authenticated,
});
export default connect(mapStateToProps)(ValidRoute);
